import * as React from 'react';

import { PaginationComponent } from './pagination.presentation';

interface Props {
    total: number;
    limit: number;
    currentPage: number;
    selectPage: (page: number) => void;
};

export class Pagination extends React.Component<Props> {
    render() {
        const { total, limit, currentPage, selectPage } = this.props;
        const totalPages = Math.ceil(total / limit);
        const start = currentPage > 3 ? currentPage - 2 : 2;
        const end = currentPage + 2;

        const pages = ['1'];
        if (start > 2) {
            pages.push('...');
        }
        for (let i = start; i <= end; i++) {
            if (i < totalPages) {
                pages.push(i.toString());
            }
        }
        if (totalPages - 2 > currentPage) {
            pages.push('...');
        }
        if (totalPages > 1) {
            pages.push(totalPages.toString());
        }

        return <PaginationComponent currentPage={currentPage} pages={pages} selectPage={selectPage} />
    }
}



// WEBPACK FOOTER //
// ./src/components/common/pagination/pagination.component.tsx